// The client the user came from travels in the query.
export const PROCEDURE_CLIENT_QUERY_PARAM = "patientId";

export const procedureShowPath = (procedureId: string, patientId?: string): string => {
  const path = `/Procedure/${procedureId}/show`;
  return patientId ? `${path}?${new URLSearchParams({ [PROCEDURE_CLIENT_QUERY_PARAM]: patientId })}` : path;
};
